import axios from 'axios';
import authHeader from './auth-header';
import BasicService from './basic.service'

class AdminService extends BasicService {
    getZones() {
        return this.checkError(axios.get(this.API_URL + 'admin/getZones', { headers: authHeader() }));
    }

    getSingleZone(zoneName) {
        return this.checkError(axios.get(this.API_URL + 'admin/getZone/' + zoneName, { headers: authHeader() }));
    }
    
    getSingleChannel(id) {
        return this.checkError(axios.post(this.API_URL + 'admin/getSingleChannel', {id: id}, { headers: authHeader() }));
    }

    deleteChannelsZone(id) {
        return this.checkError(axios.post(this.API_URL + 'admin/deleteChannelsZone', { id: id }, { headers: authHeader() }));
    }

    changeOwner(id, dbid) {
        return this.checkError(axios.post(this.API_URL + 'admin/changeOwner', { id: id, dbid: dbid }, { headers: authHeader() }));
    }

    addPremiumChannel(zoneName, dbid) {
        return this.checkError(axios.post(this.API_URL + 'admin/addPremiumChannel', { zoneName: zoneName, dbid: dbid }, { headers: authHeader() }));
    }
}

export default new AdminService();